import type { UserPreferences } from '@/components/onboarding/types';
import type { Language } from '@/i18n/translations';
import {
  EXPERIENCE_DESCRIPTORS,
  ROLE_DESCRIPTORS,
  USECASE_DESCRIPTORS,
} from '../descriptors';

/**
 * Single short sentence that tells the model who it's talking to.
 * Kept deliberately brief so the model doesn't waste tokens restating it.
 */
export function buildPersonaHeader(prefs: UserPreferences, lang: Language): string {
  const roleDesc = ROLE_DESCRIPTORS[prefs.role] ?? ROLE_DESCRIPTORS.other;
  const expDesc = EXPERIENCE_DESCRIPTORS[prefs.experience] ?? EXPERIENCE_DESCRIPTORS.beginner;
  const useCaseDesc = USECASE_DESCRIPTORS[prefs.useCase] ?? USECASE_DESCRIPTORS.sandbox;

  const role = roleDesc[lang] ?? roleDesc.en;
  const exp = expDesc[lang] ?? expDesc.en;
  const useCase = useCaseDesc[lang] ?? useCaseDesc.en;

  return lang === 'sv'
    ? `Din motpart: ${role}. Erfarenhetsnivå: ${exp}. Bygger: ${useCase}.`
    : `Your counterpart: ${role}. Experience: ${exp}. Building: ${useCase}.`;
}
